// All PayPlan copy, kept in one place so wording only changes here.

// The name PayPlan is stored under on the share list.
export const PAYPLAN_COMPANY_NAME = 'PayPlan';

export const PAYPLAN_DASHBOARD_CARD_COPY = {
  // Heading is split so "free debt advice" can be highlighted.
  headingLine1: 'You could benefit from',
  headingLine2Prefix: "PayPlan's ",
  headingHighlight: 'free debt advice',
  bulletPoints: [
    'Take the first step to getting back in control of your finances',
    'Instant support tailored to your needs',
    'Available via WhatsApp and over the phone',
  ],
  ctaLabel: 'Get debt advice',
} as const;

// Shown on the share-page card once PayPlan has been shared (the card can then only be deleted, not shared again).
export const PAYPLAN_ALREADY_SHARED_TEXT =
  'Your details have been successfully submitted to PayPlan. A representative will contact you soon to explore your options for debt management.';

// Default referral-fee disclaimer shown on share-page company cards.
export const REFERRAL_FEE_TEXT =
  "IE Hub support services are free to you. IE Hub may receive a referral fee from partner organisations if you choose to work with them.";

// Fee line shown under "Add To Share" on a share-page company card. Key = upper-case company name (partial match), value = text to show. Add an entry to show a line for another company.
export const SHARE_FEE_LINES: Record<string, string> = {
  PAYPLAN: REFERRAL_FEE_TEXT,
  "YES ENERGY": REFERRAL_FEE_TEXT,
  HOPE4U: REFERRAL_FEE_TEXT,
};
